"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatSlice = exports.FlatMedia = exports.FlatAvailability = void 0;
var FlatAvailability;
(function (FlatAvailability) {
    FlatAvailability[FlatAvailability["Available"] = 1] = "Available";
    FlatAvailability[FlatAvailability["Reserved"] = 2] = "Reserved";
    FlatAvailability[FlatAvailability["Sold"] = 3] = "Sold";
})(FlatAvailability = exports.FlatAvailability || (exports.FlatAvailability = {}));
var FlatMedia;
(function (FlatMedia) {
    FlatMedia["Building"] = "Building";
    FlatMedia["Elevation"] = "Elevation";
    FlatMedia["Dollhouse"] = "Dollhouse";
    FlatMedia["Tour"] = "Tour";
    FlatMedia["TourOutside"] = "TourOutside";
})(FlatMedia = exports.FlatMedia || (exports.FlatMedia = {}));
var FlatSlice;
(function (FlatSlice) {
    FlatSlice["Availability"] = "Availability";
    FlatSlice["Area"] = "Area";
    FlatSlice["Layout"] = "Layout";
    FlatSlice["LocationBar"] = "LocationBar";
    FlatSlice["Rooms"] = "Rooms";
    FlatSlice["Features"] = "Features";
})(FlatSlice = exports.FlatSlice || (exports.FlatSlice = {}));
//# sourceMappingURL=Flat.enums.js.map